<p class="pretext">
  {{ 'accountUi.oAuthUi.ifRequiredContinue' | transloco: { provider: provider | oAuthProvider } }}
</p>

<yat-polling-status id="65f7e079-8e83-4c0f-9faa-34060d8eeb3a" [configuration]="extendedConfiguration">{{ 'accountUi.oAuthUi.waitingForAuthentication' | transloco }}</yat-polling-status>

<p class="c-gray text-center mt-2 font-small mb-0" *ngIf="!proceeding">
  <a
    yat-link
    [routerLink]="null"
    (click)="cancelAuthentication()"
    class="link link-secondary"
    queryParamsHandling="preserve"
    [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
    matomoClickAction="oAuthPolling"
    matomoClickName="Cancel">
    {{ 'cancel' | commonWording | async }}</a
  >
</p>

<div class="row mtop-12">
  <div class="col-12">
    <p class="color-light c-gray font-small text-center mb-0 mbottom-16" yat-link>
      <transloco
        id="80e297c5-9f4b-430b-98a8-36ea8578dbd2"
        [key]="displayedTermsAndPrivacyPolicyText.key"
        [params]="displayedTermsAndPrivacyPolicyText.params"
        [scope]="displayedTermsAndPrivacyPolicyText.scope"></transloco>
    </p>
  </div>
</div>
